/** Permission catalogue and default roles (docs/05-api-contracts.md section 4). */
export const TENANT_PERMISSIONS = [
    "enterprise:manage",
    "member:manage",
    "role:manage",
    "address:manage",
    "agreement:accept",
    "enterprise:close",
    "directory:read",
    "contact:manage",
    "conversation:create",
    "department:manage",
    "inquiry:create",
    "quote:accept",
    "order:cancel",
    "order:change",
    "payment:pay",
    "receipt:confirm",
    "aftersale:open",
    "review:create",
    "order:read",
    "payment:read",
    "shop:manage",
    "product:manage",
    "product:publish",
    "cs:manage",
    "inquiry:respond",
    "quote:create",
    "review:reply",
    "shipment:manage",
    "aftersale:respond",
    "shop:payout-account",
    "payment:confirm-offline",
    "invoice:issue",
    "ledger:read",
    "aftersale:escalate",
];
export const OPERATOR_PERMISSIONS = [
    "ops:verification.review",
    "ops:catalog.manage",
    "ops:risk.manage",
    "ops:dispute.resolve",
    "ops:appeal.resolve",
    "ops:finance.reconcile",
    "ops:finance.invoice",
    "ops:payments.pause",
    "ops:config.manage",
    "ops:support.read",
    "ops:support.content-access",
    "ops:content.remove",
    "ops:audit.read",
    "ops:operators.manage",
];
const BASE = ["directory:read", "contact:manage", "conversation:create"];
const READ_TRADE = ["order:read", "payment:read"];
export const DEFAULT_TENANT_ROLES = {
    admin: [...TENANT_PERMISSIONS],
    member: [...BASE],
    buyer: [
        ...BASE,
        ...READ_TRADE,
        "inquiry:create",
        "quote:accept",
        "order:cancel",
        "order:change",
        "aftersale:escalate",
    ],
    finance_approver: [...BASE, ...READ_TRADE, "payment:pay"],
    receiving: [
        ...BASE,
        ...READ_TRADE,
        "receipt:confirm",
        "aftersale:open",
        "review:create",
        "aftersale:escalate",
    ],
    shop_admin: [
        ...BASE,
        ...READ_TRADE,
        "shop:manage",
        "product:manage",
        "product:publish",
        "cs:manage",
        "inquiry:respond",
        "quote:create",
        "order:cancel",
        "order:change",
        "review:reply",
        "shipment:manage",
        "aftersale:respond",
        "aftersale:escalate",
    ],
    sales: [
        ...BASE,
        ...READ_TRADE,
        "inquiry:respond",
        "quote:create",
        "order:cancel",
        "order:change",
        "review:reply",
        "aftersale:escalate",
    ],
    fulfilment: [...BASE, ...READ_TRADE, "shipment:manage", "aftersale:respond", "aftersale:escalate"],
    receivables: [
        ...BASE,
        ...READ_TRADE,
        "shop:payout-account",
        "payment:confirm-offline",
        "invoice:issue",
        "ledger:read",
    ],
};
/**
 * Permissions that make a role need TOTP, so a custom role cannot hand out what the MFA-required default roles
 * guard without it (ADR 0015): paying, receiving money, and administering members, roles, and closure; and, as
 * platform terms 3.3 says, managing the enterprise and handling receivables: its invoices and its ledger (card 128).
 */
export const MFA_REQUIRED_PERMISSIONS = [
    "payment:pay",
    "shop:payout-account",
    "payment:confirm-offline",
    "member:manage",
    "role:manage",
    "enterprise:close",
    "enterprise:manage",
    "invoice:issue",
    "ledger:read",
];
/**
 * Permissions only the admin role holds, never a custom role: accepting an agreement binds the enterprise, and the
 * platform terms (1.3) give that to an admin (card 128).
 */
export const ADMIN_ONLY_PERMISSIONS = ["agreement:accept"];
/** Roles whose holders must enrol TOTP before tokens carry any permissions (ADR 0015). Every operator needs it too. */
export const MFA_REQUIRED_TENANT_ROLES = [
    "admin",
    "finance_approver",
    "receivables",
];
export const DEFAULT_OPERATOR_ROLES = {
    super_admin: [...OPERATOR_PERMISSIONS],
    verification_reviewer: ["ops:verification.review", "ops:support.read"],
    catalog_risk: ["ops:catalog.manage", "ops:risk.manage", "ops:support.read"],
    dispute_resolver: ["ops:dispute.resolve", "ops:appeal.resolve", "ops:support.read"],
    finance_operations: [
        "ops:finance.reconcile",
        "ops:finance.invoice",
        "ops:payments.pause",
        "ops:audit.read",
        "ops:support.read",
    ],
    support: ["ops:support.read", "ops:support.content-access"],
};
export function isTenantPermission(value) {
    return TENANT_PERMISSIONS.includes(value);
}
export function isOperatorPermission(value) {
    return OPERATOR_PERMISSIONS.includes(value);
}
//# sourceMappingURL=permissions.js.map